export const SUBSCRIPTION_STATUS = {
  ACTIVE: "Active",
  ENDED: "Ended",
  PENDING: "Pending",
  PAID: "Paid",
};

export const SUBSCRIPTION_STATUSES = [
  {
    label: "Pending",
    value: SUBSCRIPTION_STATUS.PENDING,
  },
  {
    label: "Paid",
    value: SUBSCRIPTION_STATUS.PAID,
  },
];

export const CustomSubDateSelection = [
  { Id: 1, OptionText: "Days", value: 1 / 30 },
  { Id: 2, OptionText: "Months", value: 1 },
  { Id: 3, OptionText: "Years", value: 12 },
];
